import React, { useEffect, useState } from "react";
import "./PatientForm.scss";
import { utilService } from "../../services";

import {
  IonButton,
  IonDatetime,
  IonDatetimeButton,
  IonInput,
  IonItem,
  IonModal,
  IonTextarea,
} from "@ionic/react";
import { useToast } from "@agney/ir-toast";
import { CONSTANTS } from "../../constants";
import { useHistory } from "react-router";
import { PatientFormService } from "./PatientForm.service";
import EMTMediaUpload from "../FileShare/components/EMTMediaUpload/EMTMediaUpload";
import SearchableDropdown from "../../components/Shared/SearchableDropdown/SearchableDropdown";
import DropDown from "../../components/Shared/Dropdown/dropdown-component";
import SelectCaseType from "../../components/Shared/SelectCaseTypes/SelectCaseType";
import dayjs from "dayjs";
import customParseFormat from 'dayjs/plugin/customParseFormat';

interface ListModal {
  dataId: number;
  dataName: string;
}

const PatientFormComponent: React.FC<any> = (props) => {
  
  dayjs.extend(customParseFormat);
  const [isBasicDetails, setBasicDetails] = useState(false);
  const [isMediaDetails, setMediaDetails] = useState(false);
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [selectedDate, setSelectedDate] = useState<any>();
  const [locationData, setLocationData] = useState<any>("");
  const [genderSelection, setGenderSelection] = useState<string>("M");
  const [EMTTypes, getEMTTypes] = useState([]);
  const [EMTSites, getEMTSites] = useState([]);
  const [EMTStates, getEMTStates] = useState([]);
  const [EMTCity, getEMTCity] = useState([]);
  const [userTextMessage, setMessage]: any = useState("");
  const [selectedSite, setSelectedSite] = useState<any>(0);
  const [selectedSiteId, setSelectedSiteId] = useState<any>(0);
  const [selectedType, setSelectedType] = useState<any>(0);
  const [patientID, setPatientID]: any = useState();
  const [isPatientDetailsSubmitted, setPatientDetailsSubmitted] =
    useState(false);
  const [isCustomType, enableCustomType] = useState(false);
  const [selectedSiteData, setSelectedSiteData]: any = useState("");
  const [selectedStateData, setSelectedStateData]: any = useState("");
  const [selectedCityData, setSelectedCityData]: any = useState("");
  const [selectedTypeName, setSelectedTypeName]: any = useState("");
  const [inputFnDisabled, setInputFnDisabled] = useState(false);
  const [inputLnDisabled, setInputLnDisabled] = useState(false);
  const [patientAge, setPatientAge]: any = useState(0);
  const [dobDisabled, setDobDisabled]: any = useState(false);
  const [isSmallScreen, setIsSmallScreen]: any = useState(false);
  const [disableCity, setDisableCity]: any = useState(true);
  const [disableHospital, setDisableHospital]: any = useState(true);
  const [timeSpanList, setTimeSpanList]: any = useState([]);
  const [ageList, setAgeList]: any = useState([]);
  const [ageUnitList, setAgeUnitList]: any = useState([]);

  const [selectedETAValue, setSelectedETAValue]: any = useState<any>();
  const [selectedAgeValue, setSelectedAgeValue]: any = useState<any>();
  const [selectedAgeUnitValue, setSelectedAgeUnitValue]: any = useState<any>();
  const [mediaUploadStatus, setMediaUploadStatus]: any = useState();
  const [adjustFormHeight, setFormHeight] = useState(false);
  const [ageValueSelected, isAgeValueSelected] = useState(false);

  const [showSelectProviderModal, setShowSelectProviderModal]: any =
    useState(false);
  const [selectedProvidersNames, setSelectedProvidersNames] = useState([]);
  const [selectedCaseTypeList, setSelectedCaseTypeList]: any = useState([]);

  const [globalId, setGlobalId]: any = useState("");
  const [siteName, setSiteName]: any = useState("");
  const [siteSourceId, setSiteSourceId]: any = useState("");
  const [siteCountryCode, setSiteCountryCode]: any = useState("");
  const [siteTimezone, setSiteTimezone]: any = useState("");
  const [siteLocation, setSiteLocation]: any = useState("");
  const [networkCode, setNetworkCode]: any = useState("");
  const [isAttachmentActive, setIsAttachmentActive] = useState(false);
  const [locationDetails, setLocationDetails] = useState<any>({
    country: {
      global_country_id: "",
      country_name: "",
      country_code: null,
      country_name_code: "",
    },
    state: {
      global_state_id: "",
      state_name: "",
      state_code: "",
    },
    city: {
      global_city_id: "",
      city_name: "",
      city_code: "",
    },
    contact_details: {},
  });

  const Toast = useToast();
  let history = useHistory();
  const today = utilService.getCurrentDate();

  useEffect(() => {
    getStateList();
    getETADropDownData();
    getAgeDropDownData();
    getAgeUnitDropDownData();
    getTypesList();
    setBasicDetails(true);
    checkIfSmallScreen();
  }, []);

  let params = {
    reg_code: `${utilService.getNetwork()}`,
  };

  const getTypesList = async () => {
    const getTypesList: any = await PatientFormService.getTypesList(params);
    if (getTypesList.isSuccess) {
      getEMTTypes(getTypesList.result);
    } else {
      console.log("error");
    }
  };

  const checkIfSmallScreen = () => {
    if (utilService.getScreenSize() === "small") {
      setIsSmallScreen(true);
    } else {
      setIsSmallScreen(false);
    }
  };

  const getStateList = async () => {
    const getStateList: any = await PatientFormService.getStateList(params);
    if (getStateList.isSuccess) {
      getEMTStates(
        getStateList.result?.map((state: any) => {
          return {
            ...state,
            value: state?.state_code,
          };
        })
      );
    } else {
      console.log("error");
    }
  };

  const getETADropDownData = async () => {
    const getETADataList: any = await PatientFormService.getETAList(params);
    if (getETADataList.isSuccess) {
      setTimeSpanList(getETADataList.result);
    } else {
      console.log("error");
    }
  };

  const getAgeDropDownData = async () => {
    const getAgeDataList: any = await PatientFormService.getAgeList(params);
    if (getAgeDataList.isSuccess) {
      setAgeList(getAgeDataList.result);
    } else {
      console.log("error");
    }
  };

  const getAgeUnitDropDownData = async () => {
    const getAgeUnitDataList: any = await PatientFormService.getAgeUnitList(
      params
    );
    if (getAgeUnitDataList.isSuccess) {
      setAgeUnitList(getAgeUnitDataList.result);
    } else {
      console.log("error");
    }
  };

  const enableNextForm = () => {
    setBasicDetails(false);
    setMediaDetails(true);
  };

  const enablePrevForm = () => {
    setBasicDetails(true);
    setMediaDetails(false);
  };

  const submitForm = () => {
    let validationStatus = true;
    if (locationData === "") {
      Toast.error("Please enter patient location to continue");
      validationStatus = false;
    } else if (selectedStateData === "") {
      Toast.error("Please select state to continue");
      validationStatus = false;
    } else if (selectedCityData === "") {
      Toast.error("Please select city to continue");
      validationStatus = false;
    } else if (selectedSite === 0) {
      Toast.error("Please select site to continue");
      validationStatus = false;
    } else if (selectedETAValue === undefined) {
      Toast.error("Please select ETA to continue");
      validationStatus = false;
    } else if (firstName === "") {
      Toast.error("Please select unknown to continue");
      validationStatus = false;
    }
    if (validationStatus) {
      let params = setParams();
      addCasePatient(params);
    }
  };
  const setPatientName = (name: any) => {
    if (!name) {
      return firstName;
    } else {
      return lastName + "," + firstName;
    }
  };

  const setSelectedAge = (age: any) => {
    if (age == "Invalid Date") {
      return "unknown";
    } else if (age == "unknown") {
      return "unknown";
    } else if (age == undefined) {
      return dayjs().format("YYYY-MM-DD");
    } else {
      return dayjs(`${age}`,"DD-MM-YYYY").format("YYYY-MM-DD");
    }
  };

  const setParams = () => {
    const params = {
      case_type_list: selectedCaseTypeList,
      case_type_name: selectedProvidersNames,
      location: locationData,
      eta: selectedETAValue,
      site_guid: selectedSite,
      site_id: selectedSiteId,
      age: setAgeUnitAndValue(),
      patient_name: setPatientName(lastName),
      reg_code: `${utilService.getNetwork()}`,
      gender: genderSelection,
      dob: setSelectedAge(selectedDate),
      message: userTextMessage,
      user_guid: utilService.getLoggedUserGuid(),
      global_id: globalId,
      site_name: siteName,
      site_source_id: siteSourceId,
      site_country_code: siteCountryCode,
      site_timezone: siteTimezone,
      site_location: siteLocation,
      site_network_code: networkCode,
      first_name: firstName,
      last_name: lastName,
      middle_name: "",
      display_name: firstName,
      other_case_type:
        selectedTypeName &&
        selectedProvidersNames.find((name: string) => name === "Other")
          ? selectedTypeName
          : "",
      ...locationDetails,
    };
    return params;
  };

  const setAgeUnitAndValue = () => {
    if (selectedAgeValue) {
      return selectedAgeValue + " " + setAgeUnitValue();
    } else {
      return "";
    }
  };

  const setAgeUnitValue = () => {
    if (selectedAgeUnitValue) {
      return selectedAgeUnitValue;
    } else {
      return "";
    }
  };

  async function addCasePatient(formData: any) {
    const addCasePatientResult: any = await PatientFormService.addCasePatient(
      formData
    );
    if (addCasePatientResult.isSuccess) {
      const submittedPatientID = addCasePatientResult.result?.[0]?.patient_id;
      if (mediaUploadStatus > 0) {
        setPatientID(submittedPatientID);
        setPatientDetailsSubmitted(true);
      } else {
        enableRedirect();
        Toast.success(CONSTANTS.MESSAGES.START_A_CASE);
      }
    } else {
      console.log("error");
      setPatientDetailsSubmitted(true);
    }
  }

  const enableRedirect = () => {
    history.push({
      pathname: "/client/emt-home",
    });
  };

  const setMessageInput = (message: any) => {
    setMessage(message);
    setFormHeight(false);
  };

  const handleSiteSelection = (selectedValue: any) => {
    if (selectedValue) {
      setSelectedSiteData(selectedValue);
      let selectedSite: any = EMTSites.find(
        (selectedSiteData: any) => selectedSiteData?.id === selectedValue
      );
      setSelectedSite(selectedSite.site_guid);
      setSelectedSiteId(selectedSite?.site_id);
      setGlobalId(selectedSite.id);
      setSiteName(selectedSite.name);
      setSiteSourceId(selectedSite.source_id);
      setSiteCountryCode(selectedSite.country_name_code);
      setSiteTimezone(selectedSite.timezone);
      setSiteLocation(selectedSite.location);
      setNetworkCode(selectedSite.network_code);
      setLocationDetails({
        country: {
          country_code: selectedSite?.country_code,
          country_name: selectedSite?.country_name,
          country_name_code: selectedSite?.country_name_code,
          global_country_id: selectedSite?.global_country_id,
        },
        state: {
          global_state_id: selectedSite?.global_state_id,
          state_name: selectedSite?.state_name,
          state_code: selectedSite?.state_code,
        },
        city: {
          global_city_id: selectedSite?.global_city_id,
          city_name: selectedSite?.city_name,
          city_code: selectedSite?.city_code,
        },
        contact_details: selectedSite?.contact_details,
      });
    }
  };

  const handleStateSelection = (selectedValue: any) => {
    setFormHeight(true);
    setSelectedStateData(selectedValue);
    let selectedState: any = EMTStates.find(
      (selectedStateData: any) =>
        selectedStateData?.state_code === selectedValue
    );
    setSelectedStateData(selectedState?.state_code);
    getCityList(selectedState?.id);
    setDisableCity(false);
  };

  const getCityList = async (selectedValue: any) => {
    let params = selectedValue;
    const getCityList: any = await PatientFormService.getCityList(params);
    if (getCityList.isSuccess) {
      getEMTCity(
        getCityList.result?.map((city: any) => {
          return {
            ...city,
            // city_code is the wilaya (state) code, not unique per commune --
            // every commune in a state shares it, so react-select-search
            // always resolved to the first match (e.g. "Ain Benian" for
            // Algiers). Key on the row's unique id instead.
            value: city?.id,
          };
        })
      );
      setSelectedCityData("");
      setSelectedSiteData("");
    } else {
      console.log("error");
    }
  };

  const handleCitySelection = (selectedValue: any) => {
    setFormHeight(true);
    setSelectedCityData(selectedValue);
    let selectedCity: any = EMTCity.find(
      (selectedCityData: any) => selectedCityData.id === selectedValue
    );
    setSelectedCityData(selectedCity.id);
    getSiteList(selectedCity.id);
    setDisableHospital(false);
  };

  const getSiteList = async (selectedValue: any) => {
    let params = selectedValue;
    const getSitesList: any = await PatientFormService.getSitesList(params);
    if (getSitesList.isSuccess) {
      getEMTSites(
        getSitesList.result?.map((site: any) => {
          return {
            ...site,
            value: site?.id,
          };
        })
      );
      setSelectedSiteData("");
    } else {
      console.log("error");
    }
  };

  const setCustomCaseType = (selectedCase: any) => {
    setSelectedType(0);
    setSelectedTypeName(selectedCase.target.value);
  };

  const getOnChangeValue = (event: any) => {
    setGenderSelection(event.target.value);
  };

  const setUnknownFirstName = (event: any) => {
    if (event.target.checked) {
      setFirstName("Unknown");
      setInputFnDisabled(true);
    } else {
      setFirstName("");
      setInputFnDisabled(false);
    }
  };

  const setUnknownLastName = (event: any) => {
    if (event.target.checked) {
      setLastName("Unknown");
      setInputLnDisabled(true);
    } else {
      setLastName("");
      setInputLnDisabled(false);
    }
  };

  const getAge = (dateString: any) => {
    if (dateString === "unknown") {
      setPatientAge(0);
    } else if (dateString === "Invalid Date") {
      setPatientAge(0);
    } else {
      var today = new Date();
      var birthDate = new Date(dateString);
      var age = today.getFullYear() - birthDate.getFullYear();
      var m = today.getMonth() - birthDate.getMonth();
      if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
        age--;
      }
      setPatientAge(age);
    }
  };

  const handleETASelection = (selectedValue: any) => {
    setFormHeight(false);
    if (selectedValue) {
      let selectedETA: any = timeSpanList.find(
        (selectedETAData: any) => selectedETAData.dataId === selectedValue
      );
      if (selectedETA) {
        setSelectedETAValue(selectedETA.dataName);
      }
    }
  };

  const handleAgeSelection = (selectedValue: any) => {
    if (selectedValue) {
      isAgeValueSelected(true);
      let selectedAge: any = ageList.find(
        (selectedAgeData: any) => selectedAgeData.dataId === selectedValue
      );
      if (selectedAge) {
        setSelectedAgeValue(selectedAge.dataName);
      }
    }
  };

  const handleAgeUnitSelection = (selectedValue: any) => {
    if (selectedValue) {
      let selectedAge: any = ageUnitList.find(
        (selectedAgeData: any) => selectedAgeData.dataId === selectedValue
      );
      if (selectedAge) {
        setSelectedAgeUnitValue(selectedAge.dataName);
      }
    }
  };

  const getMediaUploadStatus = (media_data: any) => {
    setMediaUploadStatus(media_data);
  };

  const getAttachmentActive = (status: any) => {
    setIsAttachmentActive(status);
  };

  const handleChange = (event: any, type: any) => {
    const result = event.target.value.replace(/[^a-z]/gi, "");

    if (type == "firstName") {
      setFirstName(result);
    } else if (type == "lastName") {
      setLastName(result);
    }
  };

  const getSelectedProvidersList = (CaseListArrayList: any) => {
    let caseTypeIds = CaseListArrayList.map((item: any) => {
      if (item.is_selected === true) {
        return item.id;
      }
    });

    let caseTypeNames = CaseListArrayList.map((item: any) => {
      if (item.is_selected === true) {
        return item.case;
      }
    });

    let caseLists = caseTypeIds.filter(function (element: any) {
      return element !== undefined;
    });

    let caseNameLists = caseTypeNames.filter(function (element: any) {
      return element !== undefined;
    });
    setSelectedCaseTypeList(caseLists);
    checkOtherCaseTypeSelected(caseLists);
    setSelectedProvidersNames(caseNameLists);
  };

  const checkOtherCaseTypeSelected = (caseTypeList: any) => {
    const isOtherSelected = caseTypeList.includes(0);
    enableCustomType(isOtherSelected);
  };

  return (
    <div className="container patient-details-ems">
      <div className="start-a-case-header-section">
        <div className="row justify-content-center">
          <div className="col-4 icon-container">
            <div className="icon-profile ems-icon" title=""></div>
          </div>
          <div className="col-8 header-details">
            <span className="text-left sub-header-label">
              Patient Information
            </span>{" "}
            <br />
            <span className="text-left caption-label">
              Please enter the patient information below
            </span>
          </div>
        </div>
      </div>
      <div
        className={`form-details-ems ${
          adjustFormHeight ? "adjust-form-padding" : ""
        }
        `}
      >
        <div hidden={!isBasicDetails}>
          <div className="form-row">
            <div className="col-lg-8 col-md-12 mb-3">
              <label className="ems-form-label">Select case types</label>
              <IonItem className="select-cs-wrapper">
                <IonInput
                  readonly
                  className="schedule-input case-type-placeholder"
                  onClick={() => setShowSelectProviderModal(true)}
                  value={
                    selectedProvidersNames[0] === "ALL" ||
                    selectedProvidersNames.length >= 0
                      ? selectedProvidersNames.join()
                      : ""
                  }
                  placeholder="Select case types"
                ></IonInput>
              </IonItem>

              <SelectCaseType
                showModal={showSelectProviderModal}
                onOk={() => {
                  setShowSelectProviderModal(false);
                }}
                ListData={EMTTypes}
                isAllSelected={true}
                onCancel={() => {
                  setShowSelectProviderModal(false);
                }}
                getSelectedProviders={getSelectedProvidersList}
              />
            </div>
            <div className="col-lg-4 mb-3 col-sm-12" hidden={!isCustomType}>
              {isCustomType && (
                <>
                  <label className="ems-form-label">Other case type</label>

                  <input
                    type="text"
                    className="form-control custom-type emt-sac-input"
                    id="field-1"
                    maxLength={26}
                    pattern="[a-zA-Z]+"
                    placeholder="Enter other case type"
                    value={selectedTypeName}
                    onChange={(selectedCase: any) =>
                      setCustomCaseType(selectedCase)
                    }
                  />
                </>
              )}
            </div>
          </div>
          <div className="form-row">
            <div className="col-lg-4 mb-3 col-sm-12">
              <label className="ems-form-label">
                First name
                <div
                  className="form-check-inline unknown-container"
                  onChange={setUnknownFirstName}
                >
                  <label className="fn-customradio">
                    <span className="fn-label ems-form-label">
                      Unknown <span className="ocl-star">*</span>
                    </span>
                    <input
                      name="Unknown"
                      className="Unknown-input"
                      type="checkbox"
                    />
                    <span className="fn-checkmark"></span>
                  </label>
                </div>
              </label>
              <input
                type="text"
                className="form-control emt-sac-input"
                id="field-1"
                placeholder=" First name"
                pattern="[a-zA-Z]+"
                maxLength={26}
                value={firstName}
                onChange={(e) => {
                  handleChange(e, "firstName");
                }}
                disabled={inputFnDisabled}
              />
            </div>
            <div className="col-lg-4 mb-3 col-sm-12">
              <label className="ems-form-label">
                Last name
                <div
                  className="form-check-inline unknown-container"
                  onChange={setUnknownLastName}
                >
                  <label className="fn-customradio">
                    <span className="fn-label ems-form-label">Unknown</span>
                    <input
                      name="Unknown"
                      className="Unknown-input"
                      type="checkbox"
                    />
                    <span className="fn-checkmark"></span>
                  </label>
                </div>
              </label>
              <input
                type="text"
                className="form-control emt-sac-input"
                id="field-1"
                value={lastName}
                maxLength={26}
                placeholder="Last name"
                onChange={(e) => handleChange(e, "lastName")}
                disabled={inputLnDisabled}
              />
            </div>
          </div>
          <div className="form-row">
            <div className="col-lg-2 col-md-4 mb-3">
              <label className="ems-form-label">Date of birth</label>
              <div
                className={`date-picker-container form-control ${
                  dobDisabled ? "disable-dob" : ""
                }`}
              >
                {/* <EMSDatePickerComponent
                  dateFromParent={selectedDate}
                  isFromEMS={true}
                  isDOB={true}
                  getSelectedDate={(value: string) => {
                    setSelectedDate(value);
                    getAge(value);
                  }}
                ></EMSDatePickerComponent> */}

                <IonDatetimeButton
                  datetime="dob"
                  className="date-button dob-picker"
                ></IonDatetimeButton>

                <IonModal keepContentsMounted={true}>
                  <IonDatetime
                    id="dob"
                    presentation="date"
                    color="aqua"
                    max={today}
                    onIonChange={(value) => {
                      let date: any = value.detail.value;
                      let selectedAge = dayjs(date).format("DD-MM-YYYY");
                      setSelectedDate(selectedAge);
                      // getAge(value);
                    }}
                  ></IonDatetime>
                </IonModal>
              </div>
            </div>

            <div className="col-lg-3 col-md-4 mb-3">
              <label className="ems-form-label">Age</label>
              <DropDown
                siteListData={ageList}
                getSelectedItem={(value: number) => {
                  if (value) {
                    handleAgeSelection(value);
                  }
                }}
                isFromTeams={true}
                dropDownValue="Select age"
              ></DropDown>
            </div>
            <div
              className={`col-lg-3 col-md-4 mb-3 ${
                !ageValueSelected ? "disable-age-unit" : ""
              }`}
            >
              <label className="ems-form-label">Age unit</label>
              <DropDown
                siteListData={ageUnitList}
                getSelectedItem={(value: number) => {
                  if (value) {
                    handleAgeUnitSelection(value);
                  }
                }}
                isFromTeams={true}
                dropDownValue="Select age unit"
              ></DropDown>
            </div>
          </div>
          <div className="form-row">
            <div className="col-md-4 mb-3">
              <label className="ems-form-label">
                Gender <span className="ocl-star">*</span>
              </label>
              <br />
              <div className="form-check-inline" onChange={getOnChangeValue}>
                <label className="customradio">
                  <span className="radiotextsty">Male</span>
                  <input
                    type="radio"
                    checked={genderSelection === "M"}
                    value="M"
                    name="radio"
                  />
                  <span className="checkmark"></span>
                </label>
                <label className="customradio">
                  <span className="radiotextsty">Female</span>
                  <input
                    type="radio"
                    checked={genderSelection === "F"}
                    value="F"
                    name="radio"
                  />
                  <span className="checkmark"></span>
                </label>
              </div>
            </div>
          </div>
        </div>

        <div hidden={!isMediaDetails}>
          <div
            className={`form-row ${
              isAttachmentActive ? "disable-form-section" : ""
            }`}
          >
            <div className="col-lg-8 col-md-12 mb-3">
              <label className="ems-form-label">
                Patient location <span className="ocl-star">*</span>
              </label>
              <input
                type="text"
                className="form-control emt-sac-input"
                maxLength={26}
                id="field-1"
                placeholder="Patient location"
                value={locationData}
                onChange={(e) => setLocationData(e.target.value)}
              />
            </div>
          </div>
          <div className="form-row">
            <div className="col-md-8">
              <label className="ems-form-label destination-title">
                Destination
              </label>
            </div>
          </div>

          <div
            className={`form-row ${
              isAttachmentActive ? "disable-form-section" : ""
            }`}
          >
            <div className="col-md-4 mb-3">
              <label className="ems-form-label">
                State <span className="ocl-star">*</span>
              </label>
              <div className="site-drpdwn-container">
                <SearchableDropdown
                  options={EMTStates}
                  value={selectedStateData}
                  placeholder="Select state"
                  onChange={handleStateSelection}
                ></SearchableDropdown>
              </div>
            </div>
            <div
              className={`col-md-4 mb-3 ${disableCity ? "disable-input" : ""}`}
            >
              <label className="ems-form-label">
                City <span className="ocl-star">*</span>
              </label>
              <div className="site-drpdwn-container">
                <SearchableDropdown
                  options={EMTCity}
                  value={selectedCityData}
                  placeholder="Select city"
                  onChange={handleCitySelection}
                ></SearchableDropdown>
              </div>
            </div>
            <div
              className={`col-md-4 mb-3 ${
                disableHospital ? "disable-input" : ""
              }`}
            >
              <label className="ems-form-label">
                Site <span className="ocl-star">*</span>
              </label>
              <div className="site-drpdwn-container">
                <SearchableDropdown
                  options={EMTSites}
                  value={selectedSiteData}
                  placeholder="Select site"
                  onChange={handleSiteSelection}
                  isSiteDropDown={true}
                ></SearchableDropdown>
              </div>
            </div>
          </div>

          <div
            className={`form-row ${
              isAttachmentActive ? "disable-form-section" : ""
            }`}
          >
            <div className="col-md-4 mb-3">
              <label className="ems-form-label">
                ETA <span className="ocl-star">*</span>
              </label>
              <DropDown
                siteListData={timeSpanList}
                getSelectedItem={(value: number) => {
                  if (value) {
                    handleETASelection(value);
                  }
                }}
                isFromTeams={true}
                dropDownValue="Select ETA"
              ></DropDown>
            </div>
          </div>

          <div className="form-row">
            <div className="col-md-12 mb-4">
              <EMTMediaUpload
                doctorListDataFromParent={""}
                isFromPatientForm={true}
                smsThread={"smsThreadID"}
                onOk={() => {}}
                onCancel={() => {}}
                selectedUsers={""}
                patientDetailsSubmitted={isPatientDetailsSubmitted}
                patientDataID={patientID}
                siteGUID={selectedSite}
                getMediaUploadStatus={getMediaUploadStatus}
                attachmentActive={getAttachmentActive}
              ></EMTMediaUpload>
            </div>
          </div>
          <div
            className={`form-row ${
              isAttachmentActive ? "disable-form-section" : ""
            }`}
          >
            <div className="col-md-12 mb-3">
              <div className="emt-comment-box">
                <IonTextarea
                  className="textarea-div"
                  maxlength={500}
                  placeholder="Please enter your message here (maximum 500 characters)"
                  onIonChange={(e) => {
                    setMessageInput(e.detail.value);
                  }}
                  onClick={() => setFormHeight(true)}
                  id="mediaMessageUploadTextBox"
                ></IonTextarea>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="form-row button-group-ems">
        <div className="ems-group-sms-button-container">
          <div className="cancel-button-div">
            <IonButton
              color="medium"
              className={`button secondary-btn  btn-curved ${
                isAttachmentActive ? "disable-form-section" : ""
              }`}
              onClick={() => history.goBack()}
            >
              Cancel
            </IonButton>
          </div>
          {isMediaDetails && (
            <div className="send-button-div">
              <IonButton
                className={`submit-btn button primary-btn btn-curved ${
                  isAttachmentActive ? "disable-form-section" : ""
                }`}
                onClick={() => {
                  enablePrevForm();
                  setFormHeight(false);
                }}
              >
                Prev
              </IonButton>
            </div>
          )}
          {isMediaDetails && (
            <div className="send-button-div">
              <IonButton
                className={`submit-btn button primary-btn btn-curved ${
                  isAttachmentActive ? "disable-form-section" : ""
                }`}
                onClick={() => {
                  submitForm();
                }}
              >
                Submit
              </IonButton>
            </div>
          )}
          {isBasicDetails && (
            <div className="send-button-div">
              <IonButton
                className="submit-btn button primary-btn btn-curved"
                onClick={() => {
                  if (firstName !== "" || lastName !== "") {
                    enableNextForm();
                  } else {
                    Toast.error("Please select unknown to continue");
                  }
                  setFormHeight(true);
                }}
              >
                Next
              </IonButton>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default PatientFormComponent;
